import request from '../utils/request'

export function hotwordList() {
    return request({
        url: "/hotword/list",
        method: "post"
    })
}
